module.exports = __webpack_public_path__ + "static/media/login-bg.6d93f7e7.png";